import { DELETE_SUPPLIERS_MUTATION } from "@/apis/gql/apolloClient";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";

export const useDeleteSupplier = () => {
  const [deleteMutation] = useMutation(DELETE_SUPPLIERS_MUTATION);

  const handleDeleteSupplier = useCallback(
    async (supplierIds: string[]) => {
      await deleteMutation({ variables: { supplierIds } });
    },
    [deleteMutation],
  );

  return handleDeleteSupplier;
};
